import React, { Fragment } from 'react';

import { ListItemsContainer } from './styles';
import { ItemListWithExclude } from './components/ItemListWithExclude';
import { LightBlueButton } from '../../../components-reactjs/LightBlueButton';

export const FreteList = ({ selectedCfg, setIsOpen, excludeHandler }) => {
    return (
        <Fragment>
            <ListItemsContainer>
                {selectedCfg &&
                    selectedCfg.condicaoFrete.map((itemFrete, index) => {
                        return (
                            <ItemListWithExclude
                                key={index}
                                itemFrete={itemFrete}
                                type={selectedCfg.idTipoCobrancaFrete}
                                excludeHandler={excludeHandler}
                                index={index}
                            />
                        );
                    })}
                <LightBlueButton
                    onClick={() => setIsOpen(true)}
                    label="+ Adicionar Preço"
                />
            </ListItemsContainer>
        </Fragment>
    );
};
